<template>
  <div class="widget-last-activity">
    <LastActivity v-if="data" :value="chartData" class="widget-last-activity__component" />
    <footer class="widget-last-activity__footer" v-if="chartData && chartData.length">
      <component v-if="footerComp.component" :is="footerComp.component" v-bind="footerComp.props">{{
        footerComp.label
      }}</component>
      <span v-else>{{ footerComp }}</span>
    </footer>
  </div>
</template>

<script>
import LastActivity from '@/components/LastActivity/Widget'

export default {
  props: {
    data: Object,
    source: Object,
  },
  computed: {
    footerComp() {
      if (!this.source.footer) return
      return typeof this.source.footer === 'function'
        ? this.source.footer({ data: this.data, source: this.source })
        : this.source.footer
    },
    chartData() {
      if (!this.data) return {}
      return typeof this.source.data === 'function'
        ? this.source.data({
            source: this.source,
            data: this.data,
          })
        : this.source.data
    },
    aligned() {
      return this.chartData && this.chartData.length
        ? { aligned: 'stretch', height: 'auto' }
        : { aligned: 'center', height: '100%' }
    },
  },
  methods: {},
  components: { LastActivity },
}
</script>

<style lang="scss">
.widget-last-activity {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: v-bind(aligned[ 'aligned']);
  height: v-bind(aligned[ 'height']);

  &__component {
    padding: 0;
  }

  &__footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 1rem;
  }
}
</style>
